import { generateEntityCrudActionTypes } from 'syft-acp-util/store/action-types'

const autoOfferRateTypes = generateEntityCrudActionTypes('autoOfferRates')
export const AUTO_OFFER_RATES_CSV_DOWNLOAD_BEGIN = 'syftacp/AUTO_OFFER_RATES_CSV_DOWNLOAD_BEGIN'
export default { ...autoOfferRateTypes, AUTO_OFFER_RATES_CSV_DOWNLOAD_BEGIN }
